import {TAB_DISABLE} from '../../../common/tabs/tabs.constants';
import {IDS} from './tasks-action-id.constants';

export const tabsState = {
    name: IDS.app_accreditation_tasks,
    redirectTo: IDS.app_accreditation_tasks_list,
    url: `/tasks`,
    component: 'tabs',
};

export const tabListState = {
    name: IDS.app_accreditation_tasks_list,
    url: '/list',
    component: 'accTasks',
    onEnter: $ngRedux => {
        $ngRedux.dispatch({
            type: TAB_DISABLE,
            id: IDS.app_accreditation_tasks,
            state: [ IDS.app_accreditation_tasks_details ]
        })
    }
};
tabListState.onEnter.$inject = ['$ngRedux'];

export const tabDetailsState = {
    name: IDS.app_accreditation_tasks_details,
    url: '/details?task_id',
    component: 'accTasksDetails',
};